/**
 * This file contains utilities for generating paths for different things that we
 * may want to link to and for funcationality related to translating internal paths
 * into SEO-friendly "clean" URLs.
 */
import { ClientBrandConfig } from 'types/brand-config';

import { Listing } from './platform-api/__generated__/graphql';

export const getListingPath = (listing: Listing, brand: ClientBrandConfig) =>
  `${brand.paths?.listing}${listing.slug}`;
